import { render, staticRenderFns } from "./MenuItemAutocomplete.vue?vue&type=template&id=71a3ad88&class=menu-item-cost&"
import script from "./MenuItemAutocomplete.vue?vue&type=script&lang=js&"
export * from "./MenuItemAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemAutocomplete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports